import { Cart } from "@insite/client-framework/Services/CartService";

export const getProductsWithInvalidPrice = (cart: Cart | undefined) =>
    cart?.cartLines?.filter(
        cartLine =>
            (!cartLine.isPromotionItem &&
                !cartLine.quoteRequired &&
                !cartLine.allowZeroPricing &&
                cartLine.pricing?.unitNetPrice === 0 &&
                cartLine.pricing?.unitRegularPrice === 0) ||
            cartLine?.properties?.salesBlocked?.toLowerCase() === "true",
    );
